module.exports = __webpack_public_path__ + "img/jiance_en.7d7db1df.jpg";